function Help() {
  return <div>help</div>
}

export default Help
